import React from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { getUrlParams } from './util';
import { requestPasswordChange } from './thunks';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AppLogin.css';

const AppInfo = ({ loginInfo, startRequestPasswordChange }) => {
  const url = new URL(window.location);
  let params = getUrlParams(url.search);
  let token = params['token'];
  let [userId, userIdHash] = atob(token).split(':');
  console.log('userId:', userId);
  
  const OnChangeClick = (event) => {
    event.preventDefault();
    // console.log('>>> OnChangeClick');
    let password = document.getElementById('password').value;
    let password2 = document.getElementById('password2').value;
    startRequestPasswordChange({userId, password, password2, userIdHash});
  };
  
  const content = (
    <div className="AppInfo">
      <Container>
        <Row>
          <Col></Col>
          <Col xs={4}>
            <Form className="resetForm" onSubmit={OnChangeClick}>
              <br/>
              <h2>BPS - Password Change</h2>
              <br/>
              <Form.Group controlId="formUsername">
                <div className="username-container">
                  <Form.Label>Username</Form.Label>
                  <Form.Control type="text" value={userId} readOnly />
                </div>
                <div className="password-container">
                  <Form.Label>Enter new Password</Form.Label>
                  <Form.Control id="password" type="password" />
                  <Form.Label>Reenter new Password</Form.Label>
                  <Form.Control id="password2" type="password" />
                </div>
              </Form.Group>
              <Form.Text className="text-info">
                { loginInfo.infoSendStatus }
              </Form.Text>
              <input type="submit" className="btn btn-info btn-reset" 
                value="Change password" />
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </div>
  );
  
  return content;
};

const mapState = state => ({
  loginInfo: state.loginInfo,
  appInfo: state.appInfo,
})

const mapDispatch = dispatch => ({
  startRequestPasswordChange: (data) => dispatch(requestPasswordChange(data)),
})

export default connect(mapState, mapDispatch)(AppInfo);
